import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

const XAdvertisement = () => {
  const handleFollowClick = () => {
    window.open("https://x.com/Appforexwatch", "_blank", "noopener,noreferrer");
  };

  return (
    <div className="p-4">
      <Card className="w-[300px] h-[250px] bg-ad-gradient hover:bg-ad-gradient-hover shadow-ad hover:shadow-ad-hover transition-all duration-500 border-brand-red/20 overflow-hidden group cursor-pointer" onClick={handleFollowClick}>
        <div className="h-full flex flex-col items-center justify-center p-8 pt-12 text-center relative">
        {/* Logo */}
        <div className="mb-2 transform group-hover:scale-110 transition-transform duration-300">
          <img 
            src="/ads/lovable-uploads/77a45ccb-21d3-4833-a16f-5bb6d8835f5c.png" 
            alt="Appforexwatch Logo" 
            className="w-20 h-20 drop-shadow-lg rounded-xl border-2 border-brand-white/30 p-1"
          />
        </div>
        
        {/* Main text */}
        <div className="space-y-1 mb-2">
          <h2 className="text-xl font-bold text-brand-white group-hover:text-brand-red transition-colors duration-300">
            Follow for Forex Insights
          </h2>
          <p className="text-sm text-brand-white/80 leading-tight">
            Get real-time market analysis & trading signals
          </p>
        </div>

        {/* X handle */}
        <div className="mb-2">
          <span className="text-brand-red font-semibold text-lg">@Appforexwatch</span>
        </div>

        {/* CTA Button */}
        <Button 
          variant="default"
          size="sm"
          className="bg-brand-red hover:bg-brand-red-dark text-brand-white font-semibold px-6 py-2 rounded-full transform group-hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl"
        >
          Follow Now
        </Button>

        {/* Decorative elements */}
        <div className="absolute top-2 right-2 w-2 h-2 bg-brand-red rounded-full opacity-50 group-hover:opacity-100 transition-opacity duration-300"></div>
        <div className="absolute bottom-2 left-2 w-1 h-1 bg-brand-red rounded-full opacity-30 group-hover:opacity-70 transition-opacity duration-300"></div>
        </div>
      </Card>
    </div>
  );
};

export default XAdvertisement;